import React from "react";
import SearchMenu from "./search";
import Pagination from "./pagination";
import { CircularProgress, Box } from "@mui/material";

export default function RenderTableMenu({
  paginatedItems,
  allItems,
  onSearch,
  currentPage,
  totalPages,
  handlePageChange,
  onEdit,
  onDelete,
  onAdd,
  loading = false, // new prop
}) {
  return (
    <div className="table-container">
      <div
        className="table-header"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          marginBottom: "1.5rem",
          alignItems: "flex-start",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "1rem",
          }}
        >
          <h4 style={{ margin: 0 }}>Menu Items</h4>
          <button
            className="btn btn-primary menuaddbtn"
            onClick={onAdd}
            style={{ whiteSpace: "nowrap" }}
          >
            <i className="fas fa-plus"></i> Add Item
          </button>
        </div>
        <SearchMenu onSearch={onSearch} />
      </div>

      <table className="data-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Item Name</th>
            <th>Price (₹)</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="4" style={{ textAlign: "center" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    py: 3,
                  }}
                >
                  <CircularProgress size={28} />
                </Box>
              </td>
            </tr>
          ) : paginatedItems.length === 0 ? (
            <tr>
              <td colSpan="4" style={{ textAlign: "center" }}>
                No items found
              </td>
            </tr>
          ) : (
            paginatedItems.map((item, index) => (
              <tr key={item._id || index}>
                <td>{(currentPage - 1) * 10 + index + 1}</td>
                <td>{item.name}</td>
                <td>{item.price}</td>
                <td>
                  <button
                    className="btn btn-sm icon-only"
                    title="Edit Order"
                    onClick={() => onEdit(item)}
                  >
                    <i className="fas fa-edit"></i>
                  </button>
                  <button
                    className="btn btn-sm icon-only"
                    title="Delete order"
                    onClick={() => onDelete(item._id)}
                  >
                    <i className="fas fa-trash-alt"></i>
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {!loading && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          totalItems={allItems.length}
          itemsPerPage={10}
        />
      )}
    </div>
  );
}
